<template>
  <div>
    <!-- Toolbar da data table -->
    <v-toolbar flat>
      <v-toolbar-title class="font-weight-light">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>

      <v-btn :disabled="loading" :loading="loading" :color="loading ? 'info' : 'info'" icon
        title="Inserir um novo registro" @click="addCity();">
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- TABELA -->
    <v-data-table :loading="loading" :headers="headers" :search="search" :items="cities" hide-actions
      class="elevation-1">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.state }}</td>
        <td class="text-xs-center">{{ props.item.busPassValue | currency }}</td>
        <td class="text-xs-center">
          <v-chip small class="white--text font-weight-light"
            :color="props.item.active == false ? 'error' : 'success lighten-1' " :disabled="props.item.active == false">
            {{props.item.active == false ? 'Inativa' : 'Ativa'}}</v-chip>
        </td>
        <td class="justify-center layout px-0 text-xs-center">
          <v-btn icon round flat title="Editar" @click="edit(props.item);" color="info" :disabled="loading">
            <v-icon color="info">edit</v-icon>
          </v-btn>
        </td>
      </template>
      <div slot="no-results" :value="true">
        <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
      </div>
      <template slot="footer" v-if="cities.length > 0">
        <td colspan="100%">
          <strong> {{ footerText }} {{ cities.length }} </strong>
        </td>
      </template>

      <template slot="no-data" v-else>
        <strong> {{footerDynamicText}} </strong>
      </template>
    </v-data-table>



    <!-- Confirmação de desativação da cidade -->
    <v-dialog v-model="desactivationDialog" persistent :overlay="true" max-width="500px" transition="dialog-transition">
      <v-toolbar class="elevation-1" card>
        <v-toolbar-title class="font-weight-light">
          {{desactivationDialogTitle}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="error" title="Cancelar" icon round flat
            @click.stop.prevent="desactivationDialog = false, city.active = true">
            <v-icon large>clear</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <p>Ao desativar a cidade você perderá a função de utilizá-la em outras áreas</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" block outline round @click="desactivateCity">Aceitar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Insersão Alteração dos dados da cidade -->
    <v-dialog v-model="dialog" persistent class="modal-size" max-width="900px">
      <v-card v-if="loading == false">
        <v-toolbar color="white" class="elevation-1">
          <v-toolbar-title class="black--text font-weight-light">{{formTitle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-switch class="pt-switch" pt-2 v-if="city && city.active != undefined || null" :loading="loading"
              @click.prevent="city.active  == true ? desactivationDialog = true : activateCity()"
              :label='city.active ? "Ativa" : "Inativa"' v-model="city.active"></v-switch>
            <v-btn title="Cancelar" @click="closeDialog" color="error" icon round flat>
              <v-icon large>clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-container fluid grid-list-xl>
          <v-form v-model="validForm" ref="form" lazy-validation>
            <v-card-text>
              <v-layout wrap row>
                <v-flex xs12>
                  <v-select box prepend-icon="business" :items="states" item-text="name" item-value="uf"
                    v-model="city.uf" label="Estado" :rules="inputRules" required @change="filterCities"></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select box prepend-icon="label" :items="citiesOffState" :rules="inputRules" v-model="city.name" label="Cidade" required
                    :disabled="city.uf == undefined"></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-currency-field box prependInnerIcon="attach_money" class="currency-prepend-outer-icon"
                    label="Valor do passe de ônibus (R$)" v-bind="currency_config" v-model="city.busPassValue">
                  </v-currency-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn color="success lighten-1" round block :disabled="!validForm" @click.stop.prevent="save();">
                Salvar</v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
    <div>
    </div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line :timeout="snackbar.timeout" vertical right
      button>
      <strong>{{snackbar.title}}</strong>
      <v-btn dark flat @click="snackbar.visible = false">
        Fechar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import CityService from "../service/CityService";
  import States from '@/utils/StatesAndCitiesBR'
import Currency from '../utils/Currency';

  export default {
    data() {
      return {
        cities: [],
        citiesOffState: [],
        city: {},
        desactivationDialog: false,
        dialog: false,
        errors: {},
        price: 123.45,
        currency_config: Currency.real,
        /**********\
      ***Rules***
      \**********/
        validForm: true,
        inputRules: [
          v => !!v || 'Campo obrigatório',
        ],
        headers: [{
            text: "Nome",
            align: "center",
            value: "name"
          },
          {
            text: "Estado",
            align: "center",
            value: "state"
          },
          {
            text: "Valor do Passe",
            align: "center",
            value: "busPassValue"
          },
          {
            text: "Situação",
            align: "active",
            sortable: false
          },
          {
            text: "Ação",
            align: "center",
            sortable: false
          }
        ],
        loading: false,
        msgAlert: "",
        snackbar: {
          visible: false,
          title: "",
          color: "",
          timeout: 6000
        },
        savingCity: false,
        search: '',
        states: States,
        /*********\
        ***Textos**
        \*********/
        desactivationDialogTitle: "Desativar Cidade",
        emptyRecordsText: "Nenhum registro encontrado",

        emptySearchText: "Nenhuma cidade encontrada para",
        footerText: "Total de registros: ",
        loadingRecordsText: "Carregando registros...",
        title: "Listagem de Cidades"
      }
    },

    methods: {
      showAlert(message, color) {
        this.snackbar.color = color
        this.snackbar.title = message
        this.snackbar.visible = true
        this.snackbar.timeout = 6000
      }, //showAlert()
      closeDialog() {
        this.dialog = false;
        this.savingCity = false;
        this.company = {};
      },
      async initialize() {
        if (!this.loading) this.loading = true; //Se não estiver com o visual de carregamento, o ligar
        try {
          if (this.cities.length < 1) this.snackbar.visible = false;
          this.cities = await CityService.getAll(); //Receber os registros da API
          this.city = new Object();
          this.savingCity = false;
          this.search = ''; //Limpar dados
          this.dialog = false;
        } catch (error) { //Mandar o erro
          this.showAlert("Erro ao carregar empresas!", "error")
          console.log(error);
        } finally { //Tirar o visual de carregamento
          this.loading = false;
        }
      }, //initialize()

      addCity() {
        this.city = new Object();
        this.dialog = true;
      }, //addCity()

      edit(itemSelectEdit) {
        if (this.loading) return;

        this.city = itemSelectEdit;
        this.filterCities()
        this.dialog = true;
      }, //edit()
      async activateCity() {
        try {
          this.desactivationDialog = false;
          this.savingCity = true;
          this.city.active = true;
          this.dialog = false;
          await this.save();
          this.showAlert("Ativada com sucesso!", "success")
        } catch (error) {
          console.log(error)
        }
      }, //activateCity()
      async desactivateCity() {
        try {
          this.desactivationDialog = false;
          this.city.active = false;
          this.dialog = false;
          await this.save();
          this.showAlert("Desativada com sucesso!", "success")
        } catch (error) {
          console.log(error);
        }
      }, //desactivateCity()
      async save() {
        if (this.$refs.form.validate()) {
          if (this.loading) return;
          this.loading = true;
          let type = "success"
          try {
            this.dialog = false;
            if (this.city._id) {
              await CityService.update(this.city);
              this.msgAlert = "Cidade alterada com sucesso";
            } else {
              let resp = await CityService.save(this.city);
              this.msgAlert = resp.message;
              if (resp.duplicated)
                type = "error"
            }
            this.showAlert(this.msgAlert, type);
          } catch (error) {
            this.showAlert(error, "error");
            console.log(error);
          } finally {
            this.initialize();
          };
        }

      }, //save()
      filterCities() {
        this.states.forEach(state => {
          if (state.uf == this.city.uf) {
            this.citiesOffState = state.cities
            this.city.state = state.name
          }
        });
      }, //
      updateActivation() {
        console.log("City " + this.city.active)
        console.log("DesativationDialog " + this.desactivationDialog)
        if (this.city.active)
          this.desactivationDialog = true
        else
          this.activateCity()
        //city.active  == true ? desactivationDialog = true : activateCity()
      }
    }, //methods
    computed: {
      formTitle() {
        return this.city._id ? "Editar Cidade" : "Nova Cidade";
      },
      footerDynamicText() {
        let text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
        return text
      }
    }, //computed

    created() {
      this.initialize();
    }, //created()

    watch: {
      dialog(value) {
        value || this.initialize();
      },

      desactivationDialog: function () {
        if (!this.city) return;
        if (!this.city.hasOwnProperty('active')) return;
        if (this.city.active == undefined || null) return;
        if (this.savingCity == true) {
          this.desactivationDialog = false;
        }
      }
    }, //watch
  }

</script>
<style lang="css" scoped>
  >>>.pt-switch {
    padding-top: 20px;
  }

  >>>.currency-prepend-outer-icon>.v-input__control>.v-input__slot>.v-input__prepend-inner>.v-input__icon--prepend-inner>.v-icon {
    background-color: white !important;
    position: absolute;
    padding: 18px 5px;
    margin-right: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/City.vue